import SearchType from '@/ecm/variables/SearchType';
import router from '@/router/index.js';
class BrowserAlert {
    constructor() {
        this.Notification = window.Notification || window.webkitNotification;
        this.alert = '';
    }

    requestPermission = function () {
        return this.Notification.requestPermission();
    }

    show = function (alert) {
        this.alert = alert;
        const self = this;
        return Promise.resolve()
            .then(function () {
                if (Notification.permission !== 'granted') {
                    return self.requestPermission();
                }

                return Notification.permission;
            })
            .then(function (permission) {
                // "default" doesn't mean "denied"
                // It means the user has dismissed the request
                if (permission === 'denied') {
                    return new Error('No permission to show notification');
                }
                const notification = new Notification(alert.title + '\n' + alert.description);
                notification.onclick = function (event) {
                    self.onclick();
                };
            });
    }

    onclick() {
        var pattern = {
            searchPattern: this.alert.type,
            contentTypeIDs: this.alert.contentTypeIds.join(),
        };
        var route = `/search/${SearchType.Alert}/${encodeURIComponent(
            JSON.stringify(pattern)
        )}`;
        router.push(route);
    }
}

export default new BrowserAlert();